export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAGElEQVQokWNUTV70n4EMwESOplGNtNIIAOJwAjmirRmLAAAAAElFTkSuQmCC"